import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maintenance-templates-rules',
  templateUrl: './maintenance-templates-rules.component.html',
  styleUrls: ['./maintenance-templates-rules.component.sass']
})
export class MaintenanceTemplatesRulesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
